export enum ApiErrorCodes {
  InvalidCredentials = 'InvalidCredentials',
  IncorrectMandatorToken = 'IncorrectMandatorToken',
  MandatorNotActive = 'MandatorNotActive',
  NoRolesAssigned = 'NoRolesAssigned',
  InvalidRefreshToken = 'InvalidRefreshToken',
  InvalidToken = 'InvalidToken',
  TerminalNotFound = 'TerminalNotFound',
  InvalidSessionStatus = 'InvalidSessionStatus',
  UnableToOpenTerminalSession = 'UnableToOpenTerminalSession',
  CinemaNotFound = 'CinemaNotFound',
  UnableToCloseTerminalSession = 'UnableToCloseTerminalSession',
  SessionNotFound = 'SessionNotFound',
  UnableToPauseTerminalSession = 'UnableToPauseTerminalSession',
  ShowNotFound = 'ShowNotFound',
  ShowDeleted = 'ShowDeleted',
  SectorNotFound = 'SectorNotFound',
  UnableToSaveTransaction = 'UnableToSaveTransaction',
  SalesTaxNotFound = 'SalesTaxNotFound',
  UnableToSquareUpTerminalSession = 'UnableToSquareUpTerminalSession',
  SafeNotFound = 'SafeNotFound',
  UnableToCreateSafeAction = 'UnableToCreateSafeAction',
  UnableToContinueTerminalSession = 'UnableToContinueTerminalSession',
  VoucherAlreadyInBasket = 'VoucherAlreadyInBasket',
  VoucherNotFound = 'VoucherNotFound',
  VoucherNumberBelongsToCard = 'VoucherNumberBelongsToCard',
  AmountRequiredForVariableVoucher = 'AmountRequiredForVariableVoucher',
  AmountRequiredForVariablePriceProduct = 'AmountRequiredForVariablePriceProduct',
  AmountOutOfRange = 'AmountOutOfRange',
  SerialNumberRequiredForSeriesVoucher = 'SerialNumberRequiredForSeriesVoucher',
  ErrorWhileAddingVoucherToBasket = 'ErrorWhileAddingVoucherToBasket',
  TicketNotFound = 'TicketNotFound',
  TicketAlreadyCancelled = 'TicketAlreadyCancelled',
  TicketAlreadyInBasket = 'TicketAlreadyInBasket',
  ErrorWhileAddingCancelTicketToBasket = 'ErrorWhileAddingCancelTicketToBasket',
  FailedToCashVoucher = 'FailedToCashVoucher',
  VoucherNumberRequired = 'VoucherNumberRequired',
  VoucherNotInValidStatus = 'VoucherNotInValidStatus',
  ErrorWhileRetrievingVoucherByNumber = 'ErrorWhileRetrievingVoucherByNumber',
  ErrorWhileValidatingVoucherPayment = 'ErrorWhileValidatingVoucherPayment',
  CardTypeNotFound = 'CardTypeNotFound',
  CardAlreadyInBasket = 'CardAlreadyInBasket',
  CardNotLoadable = 'CardNotLoadable',
  ErrorWhileEmittingCard = 'ErrorWhileEmittingCard',
  ErrorWhileLoadingCard = 'ErrorWhileLoadingCard',
  ErrorWhileExecutingCardAction = 'ErrorWhileExecutingCardAction',
  CardNotFound = 'CardNotFound',
  ErrorWhileAddingCardToBasket = 'ErrorWhileAddingCardToBasket',
  CardNotActivated = 'CardNotActivated',
  InvalidCardAmount = 'InvalidCardAmount',
  ErrorWhileReservingCard = 'ErrorWhileReservingCard',
  ErrorWhileUnReservingCard = 'ErrorWhileUnReservingCard',
  CardExpired = 'CardExpired',
  CardNotCashCard = 'CardNotCashCard',
  CardNotValid = 'CardNotValid',
  CardNumberRequired = 'CardNumberRequired',
  CardNumberBelongsToVoucher = 'CardNumberBelongsToVoucher',
  CardNotAttachedToBasket = 'CardNotAttachedToBasket',
  CardRequiredForPriceCategory = 'CardRequiredForPriceCategory',
  ReductionCardAlreadyUsedForShow = 'ReductionCardAlreadyUsedForShow',
  ReductionCardBasketTicketLimitExceeded = 'ReductionCardBasketTicketLimitExceeded',
  ErrorWhileDetachingCardFromBasket = 'ErrorWhileDetachingCardFromBasket',
  ErrorWhileUpdatingCardPaymentForTickets = 'ErrorWhileUpdatingCardPaymentForTickets',
  ErrorWhileCashingCinecard = 'ErrorWhileCashingCinecard',
  CardNotValidOrActivated = 'CardNotValidOrActivated',
  CardLastLoadNotAvailable = 'CardLastLoadNotAvailable',
  ProductNotFound = 'ProductNotFound',
  ProductAlreadyInBasket = 'ProductAlreadyInBasket',
  ErrorWhileAddingCancelPackageToBasket = 'ErrorWhileAddingCancelPackageToBasket',
  ErrorWhileAddingCancelProductToBasket = 'ErrorWhileAddingCancelProductToBasket',
  PackageNotFound = 'PackageNotFound',
  PackageHasNoContent = 'PackageHasNoContent',
  MissingRequiredProducts = 'MissingRequiredProducts',
  InvalidProductsInPackage = 'InvalidProductsInPackage',
  ProductRequiredWithFixedAmount = 'ProductRequiredWithFixedAmount',
  PackageValidationFailed = 'PackageValidationFailed',
  TransactionPositionNotFound = 'TransactionPositionNotFound',
  PackageAlreadyInBasket = 'PackageAlreadyInBasket',
  FailedToCancelTicket = 'FailedToCancelTicket',
  FailedToFreeSeatAfterTicketCancellation = 'FailedToFreeSeatAfterTicketCancellation',
  CardProductNotFound = 'CardProductNotFound',
  CardProductAlreadyUsed = 'CardProductAlreadyUsed',
  ErrorWhileMarkingCardProductAsUsed = 'ErrorWhileMarkingCardProductAsUsed',
  ErrorWhileValidatingCardProduct = 'ErrorWhileValidatingCardProduct',
  CardProductExpired = 'CardProductExpired',
  InvalidCardType = 'InvalidCardType',
  ErrorWhileApplyingEmployeePricing = 'ErrorWhileApplyingEmployeePricing',
  ErrorWhileRemovingDiscounts = 'ErrorWhileRemovingDiscounts',
  TerminalSessionNotFound = 'TerminalSessionNotFound',
  SessionInformationNotFound = 'SessionInformationNotFound',
  ErrorRetrievingSessionData = 'ErrorRetrievingSessionData',
  FailedToRetrieveReportData = 'FailedToRetrieveReportData',
  CannotFindVoucherTypeForThisTerminal = 'CannotFindVoucherTypeForThisTerminal',
  CannotUseThisVoucherToBuyInThisTerminal = 'CannotUseThisVoucherToBuyInThisTerminal',
  CardAlreadyReservedForBasket = 'CardAlreadyReservedForBasket',
  ErrorWhileUpdatingBasketPriceCategories = 'ErrorWhileUpdatingBasketPriceCategories',
  CustomerIdRequiredForPersonalizationAction = 'CustomerIdRequiredForPersonalizationAction',
  FailedToExecuteCardAction = 'FailedToExecuteCardAction',
  BasketNotFound = 'BasketNotFound',
  UnableToGetTseDetails = 'UnableToGetTseDetails',
  UnableToTriggerTseExport = 'UnableToTriggerTseExport',
  UnableToCheckExportStatus = 'UnableToCheckExportStatus',
  UnableToDownloadTseExport = 'UnableToDownloadTseExport',
  UnableToInsertCashPointClosing = 'UnableToInsertCashPointClosing',
  InvalidDocumentContent = 'InvalidDocumentContent',
  ErrorOnPrintingViaWorker = 'ErrorOnPrintingViaWorker',
  UnableToStartTransactionFiskaly = 'UnableToStartTransactionFiskaly',
  UnableToCashInvoice = 'UnableToCashInvoice',
  UnableToCloseTransaction = 'UnableToCloseTransaction',
  UnableToFinishTransactionFiskaly = 'UnableToFinishTransactionFiskaly',
  SessionMustBeClosedBeforeInsertingCashPointClosing = 'SessionMustBeClosedBeforeInsertingCashPointClosing',
  ErrorWhilePrinting = 'ErrorWhilePrinting',
  UnableToNotifyWorkerTerminalSessionEnd = 'UnableToNotifyWorkerTerminalSessionEnd',
  UnableToNotifyWorkerTerminalSessionOpen = 'UnableToNotifyWorkerTerminalSessionOpen',
  InvalidApiKey = 'InvalidApiKey',
  MissingApiKey = 'MissingApiKey',
  NoSeatIdsProvided = 'NoSeatIdsProvided',
  MissingCinemaId = 'MissingCinemaId',
  ErrorDuringSeatsUpdating = 'ErrorDuringSeatsUpdating',
  UnableToCloseCustomerScreen = 'UnableToCloseCustomerScreen',
  UnableToOpenSafe = 'UnableToOpenSafe',
  PartialCheckoutNotAllowedWithCancelItems = 'PartialCheckoutNotAllowedWithCancelItems',
  PartialCheckoutNotAllowedWithDiscountCode = 'PartialCheckoutNotAllowedWithDiscountCode',
  GuestOrderingOrderStatusChanged = 'GuestOrderingOrderStatusChanged',
  NoSelectedItemsFound = 'NoSelectedItemsFound',
  SelectedItemsTotalExceedsPayments = 'SelectedItemsTotalExceedsPayments',
  CancellationVoucherCannotBeUsedOnThisTerminal = 'CancellationVoucherCannotBeUsedOnThisTerminal',
  VoucherSeriesArchived = 'VoucherSeriesArchived',
  CardSeriesArchived = 'CardSeriesArchived',
  VoucherTypeArchived = 'VoucherTypeArchived',
  CardTypeArchived = 'CardTypeArchived',
  PartnerCodeAlreadyUsedForShow = 'PartnerCodeAlreadyUsedForShow',
  CardCannotBeExchanged = 'CardCannotBeExchanged',
  ExchangeCardsMustDiffer = 'ExchangeCardsMustDiffer',
  CardExchangeWithoutFeeNotAllowed = 'CardExchangeWithoutFeeNotAllowed',
  CardExchangeAlreadyInBasket = 'CardExchangeAlreadyInBasket',
  ErrorWhileTransferringCardFreeEntries = 'ErrorWhileTransferringCardFreeEntries',
  CardWithdrawAmountExceedsBalance = 'CardWithdrawAmountExceedsBalance',
  MustChangePinRequired = 'MustChangePinRequired',
  PinConfirmationMismatch = 'PinConfirmationMismatch',
  InvalidPinFormat = 'InvalidPinFormat',
  PinMustDifferFromCurrent = 'PinMustDifferFromCurrent',
  DiscountConflict = 'DiscountConflict',
  DiscountCodeNotFound = 'DiscountCodeNotFound',
  DiscountCodeInactive = 'DiscountCodeInactive',
  DiscountCodeNotValidYet = 'DiscountCodeNotValidYet',
  DiscountCodeExpired = 'DiscountCodeExpired',
  DiscountCodeUsageLimitReached = 'DiscountCodeUsageLimitReached',
  DiscountCodeNotAllowedOnTerminal = 'DiscountCodeNotAllowedOnTerminal',
  DiscountCodeScopeMismatch = 'DiscountCodeScopeMismatch',
  DiscountCodeInvalidConfiguration = 'DiscountCodeInvalidConfiguration',
  DiscountCodeNotAllowedInRefund = 'DiscountCodeNotAllowedInRefund',
  ErrorWhileApplyingDiscountCode = 'ErrorWhileApplyingDiscountCode',
  DiscountCodeRedemptionFailed = 'DiscountCodeRedemptionFailed',
  OnlineOrderNotFound = 'OnlineOrderNotFound',
  OnlineOrderPositionNotFound = 'OnlineOrderPositionNotFound',
  OnlineOrderPositionNotOpen = 'OnlineOrderPositionNotOpen',
  OnlineOrderItemNotSupported = 'OnlineOrderItemNotSupported',
  OnlineOrderBasketNotEmpty = 'OnlineOrderBasketNotEmpty',
  OnlineOrderInProgress = 'OnlineOrderInProgress',
}

export enum ErrorCodes {
  CardMaximumAmountReached = 'CardMaximumAmountReached',
  CardMinimumAmountNotReached = 'CardMinimumAmountNotReached'
}
